<template>
  <div class="user-badge" :class="{ [badge.toLowerCase().replace(' ', '-')]: badge }">
    {{ badge }}
    <Tooltip v-if="tooltip">
      {{ tooltip }}
    </Tooltip>
  </div>
</template>

<script>
import Tooltip from './components/Tooltip';

export default {
  components: { Tooltip },
  props: {
    badge: { type: String, required: true, default: '' },
    tooltip: { type: String, required: false, default: '' },
  },
};
</script>

<style lang="scss" scoped>
.user-badge {
  position: relative;
  padding: 0 var(--spacing-8);
  border-radius: 100px;
  font-size: 12px;
  line-height: 19px;
  font-weight: 500;
  margin-left: var(--spacing-4);
  width: max-content;

  .tooltip {
    display: none;
  }

  &.instructor {
    background-color: var(--main-purple-light-4);
    color: var(--main-purple);
  }

  &.super-learner {
    background-color: var(--main-yellow-light-2);
    color: var(--main-yellow-shade-2);
  }

  &.business-student,
  &.business-admin {
    background-color: var(--main-dark-shade-4);
    color: var(--main-dark-shade-2);
  }

  &:hover {
    .tooltip {
      display: block;
    }
  }
}

@include bp($bp-mobile) {
  .user-badge {
    font-size: 12px;
    line-height: 20px;
    margin: 0;
  }
}
</style>
